<template>
  <v-system-bar app color="amber darken-2" dark height="40" v-if="inSwitchedSession" data-bar="session">
    <v-icon>mdi-account-switch</v-icon>
    <span class="ml-2">Estás navegando como gestor del concesionario.</span>
    <span class="ml-1" v-if="originalUserName">Cuenta original: <strong>{{ originalUserName }}</strong></span>
    <v-spacer></v-spacer>
    <v-btn text small @click="returnToOriginalSession" :loading="loading">
      <v-icon left small>mdi-account-convert</v-icon>
      Volver a mi cuenta
    </v-btn>
  </v-system-bar>
</template>
  
  <script>
  import { mapGetters } from 'vuex'
  import AuthService from '@/services/AuthService'
  
  export default {
    data() {
      return {
        loading: false,
        originalUserName: ''
      }
    },
    
    computed: {
      ...mapGetters(['IN_SWITCHED_SESSION']),
      
      inSwitchedSession() {
        return this.IN_SWITCHED_SESSION
      }
    },
    
    methods: {
      async returnToOriginalSession() {
        this.loading = true
        try {
          // Cierra el registro de acceso al dealer; si la sesión no es "acting" da 400 y se ignora
          try { await AuthService.exitDealer() } catch (e) {}
          const success = await this.$store.dispatch('RETURN_TO_ORIGINAL_SESSION')
          if (success) {
            this.$toast.success('Has vuelto a tu cuenta original')
            // Recargar la página para actualizar los permisos
            window.location.href = '/'
          } else {
            this.$toast.error('No se pudo volver a la sesión original')
          }
        } catch (error) {
          console.error('Error al volver a la sesión original:', error)
          this.$toast.error('Error al volver a la sesión original')
        } finally {
          this.loading = false
        }
      }
    },
    created() {
      // Cargar el nombre del usuario original
      try {
        const originalSession = JSON.parse(localStorage.getItem('original_session'))
        if (originalSession && originalSession.user_name) {
          this.originalUserName = originalSession.user_name
        }
      } catch (e) {
        console.error('Error al cargar información de sesión original:', e)
      }
    }
  }
  </script>
  
  <style scoped>
  .v-system-bar {
    font-weight: 500;
  }
  </style>
